import { z } from "zod";
import { localStore } from "../../../lib/store";
import { NOTIFICATION_PERMISSION_STATUSES } from "../../../services/notificationPermissionStatus";

/**
 * The last push permission THIS browser reported to the account, per account.
 *
 * It exists to tell an act from an ambient reading. `User.pushOptOut` is one
 * flag for a reader who may hold several devices, so the only honest thing it
 * can carry is the most recent answer that reader gave anywhere — and a device
 * can only know it has an answer to give by remembering what it said last.
 *
 * Without that memory the flag drifted one way. `syncPushOptOut` kept its
 * previous value in a module variable that started at `false` on every page
 * load, so a device whose permission was `denied` re-asserted the refusal on
 * every load, while a device that allowed push said nothing at all (computed
 * `false`, cached `false`, no request). One denial anywhere therefore outlived
 * every later acceptance.
 *
 * Keyed by account because the reader is what the flag describes, and one
 * browser serves several accounts (staff, shared machines). Held per browser
 * because the permission itself is per device: this is the record of what THIS
 * device has already said.
 *
 * Losing it is harmless. A cleared entry costs one redundant PATCH writing the
 * value the account already holds, which is why it is `localStorage` and not a
 * column.
 */
export const reportedPushPermissionStore = localStore(
  "reportedPushPermission",
  {},
  z.record(z.string(), z.enum(NOTIFICATION_PERMISSION_STATUSES))
);
